<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="name">Name</label>
          <InputText v-model="name" id="name"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="relationship">Relationship</label>
          <InputText id="relationship" v-model="relationship"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="dob1">Date of Birth</label>
          <date-picker v-model="dateOfBirth" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="dob1"
                     v-model="dateOfBirth"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'

export default {
  name: 'dependents',
  data() {
    return {
      name: '',
      relationship: '',
      stateNumber: '',
      filters: {},
      dateOfBirth: null,
      englishDateEnabled: true,
      loading: false,
      editing: false,
      holidayId: null
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async addHoliday() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let holiday = {
        id: this.holidayId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', holiday)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', holiday)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.dateOfBirth = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.dateOfBirth = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#dob1').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.dateOfBirth = $('#dob1').val()
        }
      })
    }
  },
  components: {
    Button,
    InputText,
    Dropdown,
    DatePicker,
    InputMask
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// dependents.vue?1694b6fa